'use client'

import { useEffect } from 'react'
import { closeModalShopFilter } from '@/utils/aside'
import FilterAll from '../shoplist/filter/FilterAll'

export default function ShopFilter({
  categories,
  currentCategoryID,
  currentBrandID,
  brands,
  currentActiveBrands,
  onChangeBrands,
  onChangePrice,
  priceMin,
  priceMax,
  onChangeCategory,
}) {
  useEffect(() => {
    const pageOverlay = document.getElementById('pageOverlay')
    if (pageOverlay) {
      pageOverlay.addEventListener('click', closeModalShopFilter)
      return () =>
        pageOverlay.removeEventListener('click', closeModalShopFilter)
    }
  }, [])

  return (
    <div className="aside-filters aside aside_right" id="shopFilterAside">
      <div className="aside-header d-flex align-items-center">
        <h3 className="text-uppercase fs-6 mb-0">篩選條件</h3>
        <button
          onClick={closeModalShopFilter}
          className="btn-close-lg js-close-aside btn-close-aside ms-auto"
        />
      </div>

      <div className="aside-content">
        <FilterAll
          categories={categories}
          currentCategoryID={currentCategoryID}
          currentBrandID={currentBrandID}
          brands={brands}
          currentActiveBrands={currentActiveBrands}
          onChangeBrands={onChangeBrands}
          onChangePrice={onChangePrice}
          priceMin={priceMin}
          priceMax={priceMax}
          onChangeCategory={onChangeCategory}
        />
      </div>
    </div>
  )
}
